class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverMediaQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.onMouseEnter = this.openOnHover.bind(this);
    this.onMouseLeave = this.closeOnHover.bind(this);
    this.syncHoverListeners = this.syncHoverListeners.bind(this);

    this.syncHoverListeners();
    if (this.hoverMediaQuery.addEventListener) {
      this.hoverMediaQuery.addEventListener('change', this.syncHoverListeners);
    } else if (this.hoverMediaQuery.addListener) {
      this.hoverMediaQuery.addListener(this.syncHoverListeners);
    }
  }

  syncHoverListeners() {
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);

    if (this.hoverMediaQuery.matches) {
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
    }
  }

  openOnHover() {
    this.closeSiblingMenus();
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  closeOnHover() {
    this.close();
    this.onToggle();
  }

  closeSiblingMenus() {
    const menuRoot = this.closest('.list-menu');
    if (!menuRoot) return;

    menuRoot.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && typeof menu.close === 'function') menu.close();
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
